module.exports = __webpack_public_path__ + "img/20190820132248532.95af1917.png";